<div class="container-fluid" style="min-height: 0px;background-color: gray;">
    <div class="row align-items-center">
        <div class="col-md mx-auto">
            <div id="myCarousel" class="carousel slide carousel-container " data-ride="carousel" data-interval="2500"
                style="text-align: center;width: auto;">
                <!-- Indicators -->
                <ol class="carousel-indicators">
                    <li *ngFor="let slide of data_slide; let i = index" [class.active]="i == 0"
                        style="background-color:#f89b82;" data-target="#myCarousel" [attr.data-slide-to]="i">
                    </li>
                </ol>
                <!-- Wrapper for slides -->
                <div class="carousel-inner">
                    <div *ngFor="let slide of data_slide; let i = index" [class.active]="i == 0" class="carousel-item">
                        <img [src]="slide.like_pic" [alt]="'Slide ' + slide.name" style="max-height:600px">
                        <!--<div class="carousel-caption">
                        <h3>{{ slide.name }}</h3>
                        <p>{{ slide.doc }}</p>
                        </div>-->
                    </div>
                </div>
                <!-- Left and right controls -->
                <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev"
                    style="color: #414141;">
                    <span class="carousel-control-prev-icon" aria-hidden="true" style="border : solid #f89b82;"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next"
                    style="color: #414141;">
                    <span class="carousel-control-next-icon" aria-hidden="true" style="border : solid #f89b82;"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
        </div>
    </div>
</div>